// FastAPI's error.response.data.detail is a plain string only when a handler
// explicitly raises HTTPException(detail="..."). A raw request-validation
// failure (422, and some framework-level errors) instead sends Pydantic's own
// array of {type, loc, msg, input, ctx} objects. Nearly every error-reporting
// call site in this app reads that same field expecting a string
// (toast.error(...), setError(...), template literals, ...) -- handing one of
// them the raw array/object throws React error #31 ("Objects are not valid as
// a React child"), and since this app has no error boundary anywhere, that
// crashes the ENTIRE page to a blank screen instead of just showing a broken
// message. Real production symptom: POST /admin/organizations returning a 422
// validation array crashed the whole admin app to a blank navy screen.
//
// Fixed once, here, at the network layer instead of patching each of the many
// call sites that already write `e?.response?.data?.detail || e.message`:
// every axios instance this is installed on normalizes `detail` to a plain
// string (or leaves it alone if it already is one) before any call site ever
// sees it, so existing call sites keep working completely unchanged.
export function normalizedErrorDetail(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msgs = detail
      .map((item) => (typeof item === "string" ? item : item?.msg || item?.message))
      .filter(Boolean);
    if (msgs.length) return msgs.join(" · ");
  }
  if (detail && typeof detail === "object") {
    return detail.msg || detail.message || "Ongeldige aanvraag";
  }
  return null;
}

export function installApiErrorNormalizer(axiosInstance) {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const detail = error?.response?.data?.detail;
      const normalized = normalizedErrorDetail(detail);
      if (normalized && normalized !== detail && error.response?.data) {
        error.response.data.detail = normalized;
      }
      return Promise.reject(error);
    },
  );
}
